var Backbone = require("backbone");
var LivingplaceMisc = require("./lpmiscstates");

var livingplacesMisc = Backbone.Collection.extend({
  model: LivingplaceMisc
});

var lps_misc = new livingplacesMisc;


module.exports = lps_misc;



// WEBPACK FOOTER //
// ./src/models/miscStates.js